<template>
  <div>
    <base-page-header title="States">
      <template #buttons>
        <div class="d-flex justify-content-end">
          <base-button title="Add State" action="primary" @click-btn="addState" />
        </div>
      </template>
    </base-page-header>
    <base-page-content>
      <template #content>
        <page-spinner v-if="ui.loading" />
        <div class="table-block" v-else>
          <table class="table">
            <thead>
              <tr>
                <th>State</th>
                <th>License #</th>
                <th>License Type</th>
                <th>W2</th>
                <th>1099</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="state in licenses" :key="state.id">
                <td>{{ state.state }}</td>
                <td>{{ state.license }}</td>
                <td>{{ state.licenseType }}</td>
                <td>{{ state.isW2 ? 'Yes' : 'No' }}</td>
                <td>{{ state.is1099 ? 'Yes' : 'No' }}</td>
                <td>
                  <button class="btn btn-outline-dark" @click="editState(state.id)">
                    Edit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </base-page-content>
    <transition name="component-fade" mode="out-in">
      <state-action-modal
        v-if="ui.showActionModal"
        :stateId="ui.selectedState"
        :states="states"
        @close="closeModal"
      />
    </transition>
  </div>
</template>

<script>
import BaseButton from '../../components/BaseButton.vue';
import BasePageContent from "../../components/BasePageContent.vue";
import BasePageHeader from "../../components/BasePageHeader.vue";
export default {
  components: {
    BasePageHeader,
    BasePageContent,
    PageSpinner: () => import("../../components/pageSpinner.vue"),
    StateActionModal: () => import("./includes/StateActionModal.vue"),
    BaseButton,
  },
  name: "States",
  data() {
    return {
      ui: {
        loading: false,
        showActionModal: false,
        selectedState: null,
      },
      licenses: [],
      states: [],
    };
  },
  beforeMount() {
    this.getStates();
  },
  methods: {
    getStates() {
      this.ui.loading = true;
      this.$http.get('/api/v1/state-licenses')
        .then((response) => {
          this.licenses = response.data.licenses
          this.states = response.data.states
          this.ui.loading = false;
        })
    },
    editState(stateId) {
      this.ui.selectedState = stateId;
      this.ui.showActionModal = true;
    },
    addState() {
      this.ui.selectedState = null;
      this.ui.showActionModal = true;
    },
    closeModal(getState = false) {
      if (getState) {
        this.getStates()
      }
      this.ui.showActionModal = false
    }
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  padding-top: 12px;
  .btn {
    &.btn-primary {
      min-width: 105px;
      color: #ffffff;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;
      background-color: #0057ed;
    }
  }
}
.table-block {
  .table {
    thead {
      tr {
        th {
          color: #000000;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 24px;
          opacity: 1;
          padding-left: 0;
          &:first-child {
            padding-left: 24px;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          padding-left: 0;
          color: #000000;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 21px;
          &:first-child {
            padding-left: 24px;
          }
        }
      }
    }
  }
}
</style>
